module.exports = __webpack_public_path__ + "static/media/anagrafica.6b8a8658.svg";